export default __webpack_public_path__ + "static/media/Diversidade.8114b0a6.png";